const expansionPanelOverrides = {};
export { expansionPanelOverrides };